import React from "react";
import { LISTING_TYPES } from "repoV2/constants/listing";
import { SidebarSectionDivider } from "@Modules/eventPage/components/SidebarSectionDivider";
import { DiscountField, OfferPromotion } from "@Modules/eventPage/components";
import { getEventCurrency } from "@Modules/eventPage/utils/getEventCurrency";
import { IPaymentSummary } from "@Modules/eventPage/components/Interfaces";
import { useReadIsOfferingSelectedInPlan } from "@Modules/eventPage/components/PlanDropdown/utils/usePlanLeafSelected";
import { IEvent } from "../../../../../interfaces/redux/store/IEvent";
import { AVAILABILITY_CHOICE } from "../../../../../../utils/constants/event";
import { getHidePaymentSummary } from "../utils/getHidePaymentSummary";
import PaymentSummary from "..";

export const PaymentSummaryWithDiscount = ({
    paymentSummaryProps,
    eventData,
    eventType,
    slots,
    className = "",
    hideDiscountField = false,
    hideOfferPromotion = false,
    isHidePaymentSummary = false,
    discountProps,
    offerPromotionProps,
}: {
    hideDiscountField?: boolean;
    hideOfferPromotion?: boolean;
    isHidePaymentSummary?: boolean;
    paymentSummaryProps: IPaymentSummary.IProps;
    eventData: IEvent.IEventData;
    eventType: number;
    className?: string;
    slots?: IEvent.IPaymentInfo["slots"];
    discountProps: any;
    offerPromotionProps: any;
}) => {
    const { disablePayment, urlQueryParams } = paymentSummaryProps;
    const hidePaymentSummary = getHidePaymentSummary({
        disablePayment,
        eventData,
    });
    const { hideTillOfferingNotSelectedInPlan } =
        useReadIsOfferingSelectedInPlan({ urlQueryParams });

    const {
        variantsData,
        selectedVariant,
        availability_choice: availabilityChoice,
    } = eventData;

    const hideTillVariantNotSelected =
        (!!variantsData?.variants && !selectedVariant) ||
        (eventData.is_offering_variants_enabled === true &&
            !eventData?.selectedOfferingVariation);

    const { eventCurrency } = getEventCurrency({ eventData });

    const showJsx =
        hideTillOfferingNotSelectedInPlan ||
        hideTillVariantNotSelected ? null : (
            <div className={className}>
                <PaymentSummary {...paymentSummaryProps} />

                {!isHidePaymentSummary && !hidePaymentSummary && (
                    <SidebarSectionDivider />
                )}

                {!hideDiscountField && (
                    <DiscountField {...discountProps.discountFieldProps} />
                )}
                {!hideOfferPromotion && (
                    <OfferPromotion
                        showOn="desktop"
                        {...offerPromotionProps}
                        currency={eventCurrency}
                    />
                )}
            </div>
        );

    // for offerings of type appointments
    if (eventType === LISTING_TYPES.APPOINTMENTS) {
        // we are hiding the payment summary when there no slots are selected
        // we are showing the payment summary for appointments, when there is availability Choice is not decided
        if (
            slots?.length ||
            availabilityChoice === AVAILABILITY_CHOICE.NOT_DECIDED
        ) {
            return showJsx;
        }
        return null;
    }
    // for all offerings except appoitments
    return showJsx;
};
PaymentSummaryWithDiscount.defaultProps = {
    className: "",
    hideDiscountField: false,
    hideOfferPromotion: false,
    isHidePaymentSummary: false,
};
